import React from "react";
import "./About.css";
import Tienda from "../images/Detallitos-filter2.png";
import { TranslationContext } from "../TranslationContext";

function About() {
  const { translation } = React.useContext(TranslationContext);
  return (
    <div className="about-container">
      <div className="about-content">
      <div className="about-text-container">
      <h1>{translation.aboutH1}</h1>
      <div className="p-container">
      <p>
      {translation.aboutP1}
      </p>
      <p className="second">
        {translation.aboutP2}
      </p>
      <h4>
        {translation.aboutH3}
      </h4>
      </div>
     
    </div> <img src={Tienda} alt="shop" className="mirror-img"/> </div></div>
  );
}

export default About;
